export default {
    logoRules: {
        nick: [{required: true, message: "请输入您的昵称"}],
    },
    resumeRules: {
        since: [{required: true, message: "请选择摄影入行年份"}],
        address: [{required: true, message: "请选择您当前居住地"}],
        camera: [{required: true, message: "请完善您的相机品牌型号"}],
        lenses: [{required: true, message: "请完善您的镜头品牌型号"}],
    },
    sinceOpts: () => {
        let opts = [];
        let date = new Date();
        for (let i = date.getFullYear(); i > 2010; i--) {
            opts.push({label: `${i}年`, value: i})
        }
        opts.push({label: "2010前", value: 2010});
        return opts;
    }
}
